import { gql } from "@apollo/client";

// Like InstalledBaseNodePath, but also resolves the node type and (when present)
// the IoT system on the node itself and every ancestor in `pathNodes`. Used by the
// event workflow to detect whether the asset's old/new location sits under an
// IoT-configured system after a path-changing event.
export const InstalledBaseNodeIotSystemPath = gql`
    query InstalledBaseNodeIotSystemPath($id: ID!) {
        installedBaseNode(id: $id) {
            id
            title
            nodeType {
                id
                key
                name
            }
            system {
                id
                title
                systemType
            }
            pathNodes {
                id
                title
                nodeType {
                    id
                    key
                    name
                }
                system {
                    id
                    title
                    systemType
                }
            }
        }
    }
`;
